export default __webpack_public_path__ + "static/media/934.aaa91c49.gif";